<template>
  <TableLayout :permissions="['business:company:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="企业名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入企业名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <!-- <el-form-item label="企业简称" prop="shortName">
        <el-input v-model="searchForm.shortName" placeholder="请输入企业简称" @keypress.enter.native="search"></el-input>
      </el-form-item> -->
      <el-form-item label="登录账号" prop="managerUserName">
        <el-input v-model="searchForm.managerUserName" placeholder="请输入登录账号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="有效期" prop="oepnValidDate">
        <el-date-picker type="daterange" v-model="oepnValidDate" value-format="yyyy-MM-dd" start-placeholder="开始日期"
          end-placeholder="结束日期" @change="selectOepnValidDate" />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="searchForm.status" clearable placeholder="请选择" @change="search">
          <el-option label="启用" :value="0"></el-option>
          <el-option label="禁用" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:company:create']">
        <li><el-button type="primary" @click="$refs.operaCompanyWindow.open('新建系统-企业信息表')"
            v-permissions="['business:company:create']">新建</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" border stripe
        @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column prop="id" label="企业编号" fixed="left" min-width="80px" align="center"></el-table-column>
        <el-table-column prop="name" label="企业名称" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="managerUserName" label="登录账号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="linkname" label="联系人" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="linkephone" label="联系人电话" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="oepnValidDate" label="有效期" min-width="140px" align="center"></el-table-column>
        <el-table-column prop="userNum" label="主播账号限制" min-width="100px" align="center">
          <template slot-scope="{row}">
            {{ row.userNum || '不限' }}
          </template>
        </el-table-column>
        <el-table-column prop="anchorUserNum" label="主播数" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="empUserNum" label="员工数" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="goodsNum" label="商品数" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="salesmanRealName" label="销售人员" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px" align="center">
          <template slot-scope="{row}">
            <!-- 0启用 1禁用 -->
            <el-switch :disabled="!containPermissions(['business:company:update'])" v-model="row.status"
              :inactive-value="1" :active-value="0" @change="changeStatus(row)">
            </el-switch>
          </template>

        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140px" align="center"></el-table-column>
        <el-table-column v-if="containPermissions(['business:company:update', 'business:company:delete'])" label="操作"
          min-width="160" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaCompanyWindow.open('编辑企业', row)"
              v-permissions="['business:company:update']">编辑</el-button>
            <el-button type="text" @click="$refs.operaCompanyValidDateWindow.open('调整有效期', row)"
              v-permissions="['business:company:update']">调整有效期</el-button>
            <el-button type="text" @click="deleteById(row)" style="color: red;" v-permissions="['business:company:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination">
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaCompanyWindow ref="operaCompanyWindow" @success="handlePageChange" />
    <OperaCompanyValidDateWindow ref="operaCompanyValidDateWindow" @success="handlePageChange" />
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaCompanyWindow from '@/components/business/OperaCompanyWindow'
import OperaCompanyValidDateWindow from '@/components/business/OperaCompanyValidDateWindow'
import { updateById } from '@/api/business/company'
export default {
  name: 'Company',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaCompanyWindow, OperaCompanyValidDateWindow },
  data() {
    return {
      oepnValidDate: [],
      // 搜索
      searchForm: {
        oepnValidDateStart: '',
        oepnValidDateEnd: '',
        managerUserName: '',
        updateTime: '',
        name: '',
        shortName: '',
        remark: '',
        managerId: '',
        linkname: '',
        linkephone: '',
        creditCode: '',
        userNum: '',
        oepnValidDate: '',
        oepnType: '',
        salesmanId: '',
        status: ''
      }
    }
  },
  created() {
    this.config({
      module: '系统-企业信息表',
      api: '/business/company',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    selectOepnValidDate(v) {
      [this.searchForm.oepnValidDateStart, this.searchForm.oepnValidDateEnd] = v
    },
    reset() {
      // this.reset()
      this.$refs.searchForm.resetFields()
      this.searchForm.oepnValidDateStart = ''
      this.searchForm.oepnValidDateEnd = ''
      this.oepnValidDate = []
      this.search()
    },
    changeStatus(row) {
      updateById(row)
        .then(() => {
          this.$tip.apiSuccess('更新成功')
        })
        .catch(err => {
          this.$tip.apiFailed(err)
        })
        .finally(() => {
          this.handlePageChange()
        })
    }
  },
}
</script>
